import React from 'react';
import { HBox, PureComponent } from "puzzle";
import { DragAndDropWrapperProps } from "./Types";

class DragAndDropWrapper extends PureComponent<DragAndDropWrapperProps, { }> {

  render() {
    const {
      dNdMessage,
      dragLeaveHandler,
      onDropHandler,
      dragOverHandler,
      show,
      className = ''
    } = this.props;

    return show ? <div
      className={`tp-drag-and-drop-dropwrap ${className}`}
      onDragLeave={dragLeaveHandler}
      onDrop={onDropHandler}
      onDragOver={dragOverHandler}
    >
      <HBox
        alignItemsCenter
        className='tp-drag-inner-wrap tp-pointer-events-none'
      >
        <div className='tp-dnd-upload-icon tp-pointer-events-none' />
        <div className='tp-drag-text tp-text-semibold tp-font-size-md tp-pointer-events-none k-text-center'>
          {dNdMessage}
        </div>
      </HBox>
    </div> : null
  }
}

export default DragAndDropWrapper;
